// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"09911f9d","407":"f69f112a","446":"8802ba2b","527":"36c83422"}[chunkId] + ".chunk.css";
};